/**
 * UUID validation helper - prevents invalid IDs from triggering database calls
 * Used by query key hooks to ensure organizationId/userId are valid before enabling queries
 */

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/**
 * Validates if a string is a proper UUID v1-5
 * Returns false for undefined, null, empty strings, or placeholder values
 */
export function isValidUuid(value: string | null | undefined): value is string {
  if (!value || typeof value !== 'string') return false;
  return UUID_REGEX.test(value);
}

/**
 * Returns the value if it's a valid UUID, otherwise undefined
 * Useful for ensuring only valid UUIDs flow through query key generation
 */
export function asValidUuid(value: string | null | undefined): string | undefined {
  return isValidUuid(value) ? value : undefined;
}
